// @flow
export const dataKey: 'settings' = 'settings';
